import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navigation } from './Navigation';
import { Helmet } from 'react-helmet';
interface MainLayoutProps {
  onLogout?: () => void;
}
export function MainLayout({
  onLogout
}: MainLayoutProps) {
  const location = useLocation();
  // Set default meta tags that can be overridden by child components
  const defaultTitle = 'ScribeTok - TikTok Transcription Tool';
  const defaultDescription = 'Convert TikTok videos to readable transcripts instantly';
  const defaultImage = 'https://scribetok.com/og-image.jpg'; // Replace with your actual default image
  return <div className="min-h-screen bg-background flex flex-col md:flex-row" data-id="element-693">
      {/* Default meta tags for SEO and link previews */}
      <Helmet data-id="element-694">
        <title data-id="element-695">{defaultTitle}</title>
        <meta name="description" content={defaultDescription} data-id="element-696" />
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" data-id="element-697" />
        <meta property="og:url" content={window.location.href} data-id="element-698" />
        <meta property="og:title" content={defaultTitle} data-id="element-699" />
        <meta property="og:description" content={defaultDescription} data-id="element-700" />
        <meta property="og:image" content={defaultImage} data-id="element-701" />
        <meta property="og:site_name" content="ScribeTok" data-id="element-702" />
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" data-id="element-703" />
        <meta name="twitter:title" content={defaultTitle} data-id="element-704" />
        <meta name="twitter:description" content={defaultDescription} data-id="element-705" />
        <meta name="twitter:image" content={defaultImage} data-id="element-706" />
      </Helmet>
      <Navigation onLogout={onLogout} data-id="element-707" />
      <main className="flex-1 overflow-auto pb-20 md:pb-0 transition-all duration-200" data-id="element-708">
        <div className="animate-fade-in" data-id="element-709">
          <Outlet data-id="element-710" />
        </div>
      </main>
    </div>;
}